import { Dialog } from "@reach/dialog";
import "@reach/dialog/styles.css";
import * as React from "react";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import { BASE_URL } from "../data/baseURL";
import Button from "./button";

const ContactFormModal = ({ countryInfo, showDialog, close }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data, e) => {
    data.contact_county = countryInfo[0]?.name;
    data.contact_county_email = countryInfo[0]?.email;
    data.contact_country_manager = countryInfo[0]?.country_manager;
    data.registration_name = countryInfo[0]?.registation_name;

    fetch(`${BASE_URL}/contact`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          close();
          e.target.reset();
          swal("Thank You!", "For Contact Us!", "success");
        }
      });
  };
  return (
    <div>
      <Dialog
        isOpen={showDialog}
        onDismiss={close}
        className="position-relative rounded-lg"
        aria-label="user-modal"
      >
        <div className="row">
          <div className="col-md-10 mx-auto">
            <h1 className="text-center fs-56 lh-64 gilroy-bold pb-5">
              {countryInfo[0]?.name}
            </h1>
            <form onSubmit={handleSubmit(onSubmit)} className="fs-16">
              <div className="row">
                <div className="col-lg-6">
                  <div className="">
                    <input
                      type="text"
                      placeholder="Name"
                      autoCapitalize="off"
                      className="form-input"
                      {...register("name", { required: true })}
                    />
                    {errors.name && (
                      <span className="text-danger ms-4">*Name Required!</span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="">
                    <input
                      type="email"
                      placeholder="Email"
                      autoCapitalize="off"
                      className="form-input"
                      {...register("email", { required: true })}
                    />
                    {errors.email && (
                      <span className="text-danger ms-4">*Email Required!</span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="">
                    <input
                      type="text"
                      placeholder="Subject"
                      autoCapitalize="off"
                      className="form-input"
                      {...register("subject", { required: true })}
                    />
                    {errors.subject && (
                      <span className="text-danger ms-4">
                        *Subject Required
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="">
                    <input
                      type="text"
                      placeholder="Phone Number"
                      autoCapitalize="off"
                      className="form-input"
                      {...register("phone", { required: true })}
                    />
                    {errors.phone && (
                      <span className="text-danger ms-4">*Phone Required!</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-5">
                <textarea
                  placeholder="Message"
                  className="form-input"
                  rows={10}
                  {...register("message", { required: true })}
                ></textarea>
                {errors.message && (
                  <span className="text-danger ms-4">*Message Required!</span>
                )}
              </div>

              <div className="pb-5">
                <Button
                  text="submit"
                  cssName="text-uppercase fw-700 fs-20 contact-btn bg-american-yellow text-white"
                />
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ContactFormModal;
